<template>
    <div v-if="isPdfPreview" class="form-control">
        {{ getDateFormatted(value) }}
    </div>
    <DatePicker
        v-else
        v-model="selectedDate"
        class="w-100"
        value-type="YYYY-MM-DD"
        format="DD/MM/YYYY"
        :disabled-date="disableDate"
        :formatter="momentFormat"
        @change="onChange"
    />
</template>

<script>
import DatePicker from 'vue2-datepicker'
import moment from 'moment'

export default {
    name: 'AppDatePicker',
    components: {
        DatePicker,
    },
    props: {
        value: {
            type: String,
            default: '',
        },
        disableDate: {
            type: Function,
            default: () => false,
        },
    },
    data() {
        let momentFormat = {
            //[optional] Date to String
            stringify: (date) => {
                return date ? moment(date).format('DD/MM/YYYY') : ''
            },
            //[optional]  String to Date
            parse: (value) => {
                if (value && moment(value, ['YYYY-MM-DD', 'DD/MM/YYYY'], true).isValid()) {
                    if (value.indexOf('-') > 0) {
                        return moment(value, 'YYYY-MM-DD').toDate()
                    } else {
                        return moment(value, 'DD/MM/YYYY').toDate()
                    }
                }

                // this.value = null
                this.$emit('input', null)
                return null
            },
        }

        return {
            momentFormat,
            isPdfPreview: false,
            selectedDate: '',
        }
    },
    watch: {
        value: function (newVal, oldVal) {
            if (newVal !== oldVal && newVal === null) {
                this.$emit('input', null)
            }
        },
    },
    mounted() {
        this.isPdfPreview = this.$root.inPdfPreviewForm(this.$el)
    },
    methods: {
        onChange(data) {
            let newDate = data
            if (data.indexOf('/') > 0) {
                newDate = moment(data, 'DD/MM/YYYY').format('YYYY-MM-DD')
                sessionStorage.setItem('selectedDate', newDate)
            }
            this.$emit('input', newDate)
        },
        getDateFormatted(value, format = 'DD/MM/YYYY') {
            return moment(value).format(format)
        },
    },
}
</script>

<style lang="scss">
.mx-input-wrapper {
    input {
        height: 38px;
        font-size: 1rem;
        &:focus {
            color: #212529;
            border-color: #86b7fe;
            outline: 0;
            box-shadow: 0 0 0 0.25rem rgb(13 110 253 / 25%);
        }
    }
}
</style>
